import { getters } from '@/modules/core/app/helpers/store';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';

export class StatusPageRouteConfig extends PageRouteConfig {
  /**
   * @override
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    const userSettings = getters.session.getUserSettings();
    return userSettings.isSuperAdmin();
  }
}
